import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  saving: false,
  error: null,
  items: [],
  selected: null,
  count: 0,
  page: 1,
  isChanged: false
};

export const proximityNotificationSlice = createSlice({
  name: "proximityNotifications",
  initialState,
  reducers: {
    load: (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.items = [];
    },
    setProximityNotificationPage: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.items = payload;
    },
    addProximityNotitications: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.items = [...state.items, ...payload];
    },
    setSaving: (state, { payload }) => {
      state.saving = payload;
    },
    delete: (state, { payload }) => {
      state.items = state.items.filter((item) => item.id !== payload);
      state.selected = null;
    },
    update: (state, { payload }) => {
      state.items = state.items.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
      state.selected = null;
    },
    setSelected: (state, { payload }) => {
      state.selected = payload;
    },
    setPage: (state, { payload }) => {
      if (payload <= state.count) {
        state.page = payload;
      }
    },
    setChanged: (state, { payload }) => {
      state.isChanged = payload;
    },
  },
});
export const proximityNotificationAction = proximityNotificationSlice.actions;
export default proximityNotificationSlice.reducer;
